import flatMap from 'lodash/flatMap';
import { batch } from 'react-redux';
import { AppThunkAction, RootState } from '../reducers/root-reducer';
import {
  fetchFormFieldsError,
  fetchFormFieldsRequest,
  fetchFormFieldsSuccess
} from '../reducers/form-fields/form-fields.reducer';
import { ValuesToSendInterface } from '../../types/form.types';

const onError = <S = RootState>(errorMessage: string): AppThunkAction<S> => {
  return async (dispatch): Promise<void> => {
    dispatch(fetchFormFieldsError(errorMessage));
  };
};

const postFormAction = <S = RootState>(
  fetchFunction: (data: ValuesToSendInterface, token: string) => Promise<void>,
  data: ValuesToSendInterface,
  recaptchaToken: string
): AppThunkAction<S> => {
  return async (dispatch): Promise<void> => {
    // REQUEST STARTED
    dispatch(fetchFormFieldsRequest());

    await fetchFunction(data, recaptchaToken)
      .then(() => {
        batch(() => {
          dispatch(fetchFormFieldsSuccess());
        });
      })
      .catch((error) => {
        if (error.response) {
          // Request made and server responded
          // console.log(error.response.data);
          // console.log(error.response.status);
          // console.log(error.response.headers);

          const errorsText = flatMap(
            error.response.data.meta.messages,
            (value) => value.text
          );

          return batch(() => {
            dispatch(onError<S>(errorsText.join(', ')));
            throw new Error();
          });
        }

        if (error.request) {
          // The request was made but no response was received
          return batch(() => {
            dispatch(onError<S>('Ups... something went wrong'));
            throw new Error();
          });
        }

        return batch(() => {
          dispatch(onError<S>(error.toString()));
          throw new Error();
        });
      });
  };
};

export default postFormAction;
